module.exports = __webpack_public_path__ + "static/media/banner-drlicita.4b5411dc.png";